import React, { Component, Fragment } from "react";
import Logs from "../../../Components/Admin/Logs";

export default class PageAdminLogs extends Component {
    render() {
        return (
            <Fragment>
                <Logs />
            </Fragment>
        );
    }
}
